import _styled, { default as _styled2 } from "styled-components";
import React from "react";
import * as RadixAccordion from "@radix-ui/react-accordion";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { FooterGroup } from "~/features/app/app-footer/footer-links/footer-group";
import { FooterGroupDropdown } from "~/features/app/app-footer/footer-links/footer-group-dropdown";
const fragment = graphql(`
  fragment FooterLinks on footerLinks_group_BlockType {
    ...FooterGroup
  }
`);
type Props = {
  groups: FragmentType<typeof fragment>[];
};
export function FooterLinks(props: Props) {
  const {
    groups
  } = props;
  const items = useFragment(fragment, groups);
  const [openValue, setOpenValue] = React.useState("0");
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  if (!hasItems(items)) {
    return null;
  }
  return <>
      <_StyledDiv>
        {items.map((group, idx) => <div key={idx}>
            <FooterGroup {...group} />
          </div>)}
      </_StyledDiv>
      <_StyledRadixAccordionRoot type="single" collapsible value={openValue} onValueChange={setOpenValue} $_css={[{
      "width": "100%",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-divide-y-reverse": "0",
        "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
        "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
      },
      "@media (min-width: 1024px)": {
        "display": "none"
      }
    }, themeStyle.border]}>
        {items.map((group, idx) => <FooterGroupDropdown key={idx} value={String(idx)} isOpen={openValue === String(idx)} {...group} />)}
      </_StyledRadixAccordionRoot>
    </>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-10qosvo-0"
})({
  "display": "none",
  "width": "100%",
  "@media (min-width: 1024px)": {
    "display": "grid",
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
    "gap": "8rem"
  },
  "@media (min-width: 1280px)": {
    "gridTemplateColumns": "repeat(4, minmax(0, 1fr))"
  }
});
var _StyledRadixAccordionRoot = /*#__PURE__*/_styled2(RadixAccordion.Root).withConfig({
  displayName: "footer-links___StyledRadixAccordionRoot",
  componentId: "sc-1ozn6q0-0"
})(["", ""], p => p.$_css);